<template>
  <div class="messengers-settings-page">
    <div class="messengers-settings-page__title">
      <template
        v-if="isWidget && isWidgetRequiredMessenger && !hasActivatedMessenger"
      >
        {{ $t("messeger.messengers_settings_if_widget_required_messengers") }}
      </template>
      <template v-else>
        {{ $t("messeger.messengers_settings") }}
      </template>
    </div>
    <div class="messengers-settings-page__subtitle">
      <messages-num no-margin style="position: relative; top: -1px" />
      {{ $t("messeger.pick_messengers_for_notifications") }}
    </div>
    <messengers-settings></messengers-settings>
  </div>
</template>
<script>
import messengersSettings from "@/components/Messengers/settings.vue";
import messagesNum from "@/components/Resp/messagesCounter.vue";
import { WIDGET_REQUIRED_MESSENGER } from "@/constants";
import config from "src/config";

export default {
  name: "MessengersSettingsPage",
  components: {
    messengersSettings,
    messagesNum,
  },
  data() {
    return {
      WIDGET_REQUIRED_MESSENGER,
      config,
    };
  },
  computed: {
    isWidget() {
      return this.$store.state.isWidget;
    },
    isWidgetRequiredMessenger() {
      return config(WIDGET_REQUIRED_MESSENGER);
    },
    hasActivatedMessenger() {
      return (
        this.$store.state.user &&
        this.$store.state.user.user &&
        this.$store.state.user.user.data &&
        this.$store.state.user.user.data.msgr &&
        this.$store.state.user.user.data.msgr.mgs &&
        this.$store.state.user.user.data.msgr.mgs.length
      );
    },
  },
};
</script>
<style lang="scss">
.messengers-settings-page {
  max-width: 500px;
  padding: 25px 20px;
  background: #fff;
  box-shadow: 0px 4px 20px rgba(53, 49, 81, 0.06);
  border-radius: 12px;

  .messengers-settings {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  &__title {
    margin-bottom: 9px;
    font-size: 18px;
    font-weight: 700;
  }
  &__subtitle {
    margin-bottom: 25px;
    color: #838a99;
    font-weight: 500;
  }
}
</style>